// extracted by mini-css-extract-plugin
export default {"sec_heading":"Group_sec_heading__H0Ktu","groups":"Group_groups__gP5TE"};